import { ReactElement } from "react";
import Layout from "../components/layout";
import PromoCodeList from "../components/PromoCode";

const PromoCodePage = (): ReactElement => {
  return (
    <Layout>
      <PromoCodeList />
    </Layout>
  );
};

export default PromoCodePage;
